import { observable, transaction, map, computed, when, reaction, runInAction, action, toJS, autorun } from 'mobx';
import Api from './api';
class PartnerStore{
  constructor() {

  }
  @observable loaded = false;
  @observable data = [];
  @observable refTitle = '客户名称|助记码|编码|电话';
  @observable IsNextPage = true;
  @observable params = {
    KeyWord: '',
    PageIndex: 1,
    PageSize: 12,
    IsDisabled: true,
    ClassID: '',
    UserRange: 0,
    PartnerType: '01'
  }

  @computed get displayData() {
    return toJS(this.data);
  }
  
  @action init() {
    this.getPartnerList();
  }

  @action getPartnerList() {
    autorun(async () => {
   
      if (!this.IsNextPage || this.IsNextPage == 'false') {
        return;
      }
      let data = await Api.GetCustomerInfo(this.params);
      runInAction(() => {
        if (this.params.PageIndex == 1) {
          this.data = data.Customer;
        } else {
          data.Customer.forEach(item => {
            this.data.push(item);
          })
        }
        this.IsNextPage = data.IsNextPage;
        this.loaded = true;
      })
    })
  }

  @action changeFilterParams(type, value) {
    let obj = {[type]: value};
    if (type !== 'PageIndex') {
      obj = {...obj, PageIndex: 1}
      this.IsNextPage = true;
    } else if (!this.IsNextPage || this.IsNextPage == 'false') {
      return;
    }
    this.params = {...this.params, ...obj};
    if(this.params.PartnerType == '00'){
      this.refTitle = '供应商名称|助记码|编码|电话'
    }
  }

  @action changeDataByType(type, id, value) {
    this.data[id][type] = value;
    //  = {...this.data[id], [type]: value};
    // this.data = [...this.data];
  }

}

export default PartnerStore;